import { ProtectedRoute } from '@shared/auth';

import { MarketBasketsDependencies } from '@/features/market-baskets';

const MarketBasketsLayout = () => {
  return <ProtectedRoute component={MarketBasketsDependencies} policies={['canManageMarketBaskets', 'isAssignedToAnyClient']}/>;
};

export default MarketBasketsLayout;
